import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { TASK_HEAD_EMPLOYEES_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateEmployees from './components/CreateBoard/CreateEmployees';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityAssessmentEmployees from './interfaces/IMaterialityAssessmentEmployees';

import styles from './scss/MaterialityAssessmentBoard.module.scss';

function MaterialityAssessmentEmployeesView({
  isEmptyList, loading, addStakeholder, goBack, goToNextMaterialityAssessment, openModal,
  employees, onEditRecord, onLoadMore, hasMore, isLoadingMore, onDeleteItem,
  selectedItem, recordId, currentId, setEmployees, setOpenModal, vcmName, vcmId,
  employeesEnumList, isViewOnly = false,
}: IMaterialityAssessmentEmployees) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantEmployees')}
            buttonTitle={t('materialityAssessment.addEmployee')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyEmployeeDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {employees.length > 0 && (
                  <ItemsTable
                    items={employees}
                    headCells={TASK_HEAD_EMPLOYEES_CELLS}
                    onEditRecord={onEditRecord}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onDeleteItem={onDeleteItem}
                    employeesEnumList={employeesEnumList}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CreateEmployees
        open={openModal}
        onClose={addStakeholder}
        title={t('materialityAssessment.addAnEmployee')}
        selectedItem={selectedItem}
        recordId={recordId}
        currentId={currentId}
        setEmployees={setEmployees}
        setOpenModal={setOpenModal}
        employeesEnumList={employeesEnumList}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentEmployeesView;
